// extracted by mini-css-extract-plugin
export default {"table":"PreviousVersions_table__v9Cl1","header":"PreviousVersions_header__-OHM6","cell":"PreviousVersions_cell__VHZtD"};